import type { Form, FormAction, FormFillContext, VisibilityRule } from './types';
import { checkRule, prepareFormData } from './utils';
import { useUserStore } from 'vince-core/stores/userStore';

export const useFormFillStore = defineStore('formFillStore', () => {
    const form = ref<Form>();
    const preview = ref<boolean>(false);

    const userStore = useUserStore();

    // Unprocessed source data that form fields and values will be extracted from
    const sourceData = ref<unknown>({});
    const formData = ref<Record<string, unknown>>({});

    const context = ref<FormFillContext>();


    function executeAction (action: FormAction) {
        if (preview.value) {
            return;
        }
        // TODO implement action executions
        JSON.stringify(action.type);
    }

    function initialize (rc: Form, data: unknown, previewMode: boolean) {
        form.value = rc;
        preview.value = previewMode;
        sourceData.value = data;
        formData.value = prepareFormData(rc.data, data, previewMode);

        const ui = userStore.userInfo!;
        context.value = {
            email: ui.email,
            firstName: ui.firstName,
            groups: ui.groups,
            lastName: ui.lastName,
            nickname: ui.nickname,
            tags: ui.tags
        };
    }

    function setFieldValue (fieldId: string, value: unknown) {
        // TODO add validation?
        formData.value[fieldId] = value;
    }

    function isVisible (visibilityRules: VisibilityRule[]): boolean {
        if (visibilityRules.length === 0) {
            return true;
        } else {
            const fieldDataTypes = Object.fromEntries(form.value!.data.fields.map(it => [it.id, it.sourceFieldType]));
            for (const rule of visibilityRules) {
                if (!checkRule(rule, formData.value, fieldDataTypes, context.value!)) {
                    return false;
                }
            }
            return true;
        }
    }

    return {
        initialize,
        executeAction,
        setFieldValue,
        formData,
        isVisible
    };
});
